<script lang="ts">
	import type { Snippet } from 'svelte';

	const { title, open, children }: { title: string; open?: boolean; children?: Snippet } = $props();
</script>

<div class="bg-base-100 collapse-arrow collapse mb-3 rounded-none p-3">
	<input type="checkbox" checked={open} />

	<h2 class="collapse-title p-0">
		{title}
	</h2>
	<div class="collapse-content mt-2 flex w-full flex-col gap-2">
		{@render children?.()}
	</div>
</div>
